// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyC_Xkh7-TnNXrh825ajeDnkG6VWZy9KwG0",
    authDomain: "social-deduction-ca7ea.firebaseapp.com",
    projectId: "social-deduction-ca7ea",
    storageBucket: "social-deduction-ca7ea.firebasestorage.app",
    messagingSenderId: "86937981580",
    appId: "1:86937981580:web:4bd76fee9b64a612cd61a9",
    measurementId: "G-FG0QPGK3RF"
  };

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
